import { Box, Modal } from "@mui/material";
import { prospectTimelineDetails } from "_controllers/officer";
import { useEffect, useState } from "react";
import { formatedDate } from "utils/helper";

const style1 = {
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    boxShadow: "0px 1px 3px 0px",
    p: 4,
    maxHeight: 600,
    height: 600,
    overflowX: "hidden"

};
const style = {
    wraper: {
        borderLeft: "2px dashed ",
        // borderBottom: "2px dashed ",
        padding: "20px 0 0 50px"
    },
    container: {
        display: "flex",
        flexDirection: "column"
    },
    main: {
        boxShadow: "0px 0px 1px 0px",
        margin: "5px 0px",
        padding: "5px 5px",

    },
    time: {
        color: "green"
    },
    message: {
        color: "black"
    }
}
const TimelinePreviewSection = ({ openTimeline, handleTimelineClose, prospectId1 }) => {
    const [prospectTimeline, setProspectTimeline] = useState([])
    useEffect(async () => {
        let timeline = await prospectTimelineDetails(prospectId1)
        setProspectTimeline(timeline.data)
    }, [])
    return <>
        <Modal
            open={openTimeline}
            onClose={handleTimelineClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style1}>
                <div style={style.container}>
                    <h3>Prospect Timeline</h3>
                    {prospectTimeline.length > 0 ? prospectTimeline.map((n, i) => {
                        return (
                            <>
                                <div style={style.wraper}>
                                    <div style={style.main}>
                                        <div style={style.time}>Time {formatedDate(n.createdAt)}</div>
                                        <div style={style.message}>Message: {n.message}</div>
                                    </div>
                                </div>
                            </>
                        )
                    }) : <div>No Record Found</div>}


                </div>
            </Box>
        </Modal>
    </>
}
export default TimelinePreviewSection